export default __webpack_public_path__ + "static/media/ic_age_limit.73e5b66b.png";